const defaultOptions = {
    webUrl: 'https://www.s7.ru/click-to-call/',
    appUrl: 'https://link.api.s7.ru/clicktocall',
    windowFeatures: 'width=350,height=500,resizable=no,toolbar=no,menubar=no,location=no,status=no',
    analytics: {
        step: 'footer',
        item_name: 'Звонок онлайн',
        ux_ui: 'BUTTON',
        flow: 'main',
        application: 'portal'
    },
    web: true
};

export { defaultOptions };
//# sourceMappingURL=clickToCall.contracts.js.map
